import { Capacitor } from '@capacitor/core';

/** Matches Aria mobile layout / swipe-to-dismiss breakpoints in CSS. */
export const MOBILE_TOUCH_GESTURES_MEDIA_QUERY = '(max-width: 768px)';

export function getIsNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

export function getIsWebApp(): boolean {
  if (typeof window === 'undefined') return false;
  if ((window.navigator as Navigator & { standalone?: boolean }).standalone === true) {
    return true;
  }
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  return false;
}

export function getIsMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(MOBILE_TOUCH_GESTURES_MEDIA_QUERY).matches;
}

/**
 * Whether custom touch gestures (swipe-to-dismiss, drawer drag) should run.
 * Native shell, installed PWA, or mobile-width browser.
 */
export function getSupportsTouchGestures(): boolean {
  return getIsNativeApp() || getIsWebApp() || getIsMobileViewport();
}
